import * as React from 'react'

function SignOutIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17.7} height={17.4} viewBox="0 0 17.7 17.4" {...props}>
      <g data-name="Group 52578">
        <g data-name="Group 52371">
          <g data-name="Group 52370">
            <path
              data-name="Path 65141"
              d="M12.804 2.944V0H0v16h12.8v-3.155"
              fill="none"
              stroke="CurrentColor"
              strokeLinecap="square"
              strokeWidth={1.4}
              transform="translate(-.799 -.878) translate(1.499 1.578)"
            />
            <g data-name="Group 52369">
              <path
                data-name="Path 65142"
                d="M.577 2.969h10.188"
                fill="none"
                stroke="CurrentColor"
                strokeWidth={1.4}
                transform="translate(-.799 -.878) translate(1.499 1.578) translate(6.234 4.609)"
              />
            </g>
          </g>
        </g>
        <path
          data-name="Subtraction 91"
          d="M5.46.8l4.09 4.09H7.608L5.46 2.784 3.349 4.893H1.37z"
          transform="translate(-.799 -.878) rotate(-90 10.584 4.084)"
          fill="#78838a"
        />
      </g>
    </svg>
  )
}

export default SignOutIcon
